var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36499 19.1415C8.78657 20.669 10.1861 21.7907 11.8476 21.7907H15.7009C17.696 21.7907 19.3133 20.1733 19.3133 18.1782V10.4716C19.3133 8.81011 18.1916 7.41059 16.6642 6.98902V14.3249C16.6642 16.9851 14.5077 19.1415 11.8476 19.1415H8.36499Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9943 3.00586C5.99919 3.00586 4.38184 4.62321 4.38184 6.61832V14.3249C4.38184 16.32 5.99919 17.9374 7.9943 17.9374H11.8476C13.8427 17.9374 15.4601 16.32 15.4601 14.3249V6.61832C15.4601 4.62321 13.8427 3.00586 11.8476 3.00586H7.9943Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.23896c2c2c50969c49cc5f347bbf0e29.svg";
export { ForwardRef as ReactComponent };